import { render, staticRenderFns } from "./FormItemConfig.vue?vue&type=template&id=887ac2d8&"
import script from "./FormItemConfig.vue?vue&type=script&lang=js&"
export * from "./FormItemConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports